// removed by extract-text-webpack-plugin
module.exports = {"root":"Question__root___2KnRa","question":"Question__question___3zH-Q","timer":"Question__timer___16WU_"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/interaction/children/sections/question/Question.scss
// module id = 989
// module chunks = 0